import { Component, OnInit } from '@angular/core';
import { SubSink } from 'subsink';
import { Pagination } from 'src/app/shared/models/pagination.model';
import { WithdrawModel, WithdrawRialStatus } from 'src/app/shared/models/withdraw.model';
import { User } from 'src/app/shared/models/user.model';
import { Currency } from 'src/app/shared/models/currency.model';
import Swal from 'sweetalert2';
import { ReportService } from 'src/app/shared/service/report.service';
import { LazyLoadEvent } from 'primeng/api';
import { LocalDataSource } from 'ng2-smart-table';
import { DateService } from '../../../../../shared/service/date.service';
import { UserService } from '../../../../../shared/service/user.service';
import * as XLSX from 'xlsx';
import { DateFormatPipe } from '../../../../../shared/pipes/jdate.pipe';
import { WithdrawTreasury } from '../../../../../shared/models/withdraw-treasury.model';

@Component({
  selector: 'app-withdraw-treasury',
  templateUrl: './withdraw-treasury.component.html',
  styleUrls: ['./withdraw-treasury.component.scss'],
  providers: [DateFormatPipe]
})
export class WithdrawTreasuryComponent implements OnInit {
  sub = new SubSink();
  tableLoading = true;
  error: any = {};
  pagination: Pagination<WithdrawTreasury> = new Pagination<WithdrawTreasury>();
  loading = true;
  includedUsers: User[] = [];
  selectedCurrency: Currency[] = [];
  Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });
  status!: WithdrawRialStatus;
  WithdrawRialStatus = WithdrawRialStatus;
  succeed!: boolean;
  startDate!: string;
  endDate!: string;
  source: LocalDataSource = new LocalDataSource();
  token: string | undefined;

  constructor(
    private reportService: ReportService,
    private dateService: DateService,
    private userService: UserService,
    private dateFormat: DateFormatPipe
  ) {}

  filterTable($event: any = {}): void {
    this.startDate = $event.startDate ?? this.dateService.previousWeek();
    this.endDate = $event.endDate ?? this.dateService.todayStringGregorian();
    const filters: any = {
      start_time: `${this.startDate} 00:00:00`,
      end_time: `${this.endDate} 23:59:59`,
      succeed: this.succeed,
      userId: this.includedUsers
    };
    this.tableLoading = true;
    this.userService.getTreasuryWithdraw(filters).subscribe(
      (response) => {
        this.tableLoading = false;
        this.pagination = response;
      },
      (error) => {
        if (error.status === 422) {
          this.Toast.fire({
            icon: 'error',
            title: error.validationError.endTime?.[0] || error.validationError.startTime?.[0]
          });
        } else {
          this.error = error.validationError;
        }
        this.tableLoading = false;
      }
    );
  }

  exportexcel() {
    if (this.pagination.data) {
      const worksheet = XLSX.utils.json_to_sheet(
        this.pagination.data.map((res) => {
          return {
            'شناسه کاربر': res.userId,
            'شماره شبا': res.iban,
            مقدار: res.amount,
            کارمزد: res.fee,
            'درگاه پرداخت': res.provider,
            تاریخ: this.dateFormat.transform(res.createdAt, 'jYYYY/jMM/jDD HH:mm')
          };
        })
      );
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(
        workbook,
        `گزارش برداشت${this.dateFormat.transform(
          this.startDate,
          'jDD_jMM_jYYYY'
        )}-${this.dateFormat.transform(this.endDate, 'jDD_jMM_jYYYY')}.xlsx`
      );
    }
  }

  getWithdrawList(event: LazyLoadEvent = {}, $event: any = {}): void {
    if (this.startDate === undefined && this.endDate === undefined) {
      this.startDate = $event.startDate ?? this.dateService.previousMonth();
      this.endDate = $event.endDate ?? this.dateService.todayStringGregorian();
      this.succeed = true;
      this.status = $event.status;
    }
    this.loading = true;
    const user_id = this.includedUsers.map((user) => user.id);
    this.reportService
      .getTreasuryRialWithdrawList(
        user_id,
        event.rows,
        this.status,
        `${this.startDate} 00:00:00`,
        `${this.endDate} 23:59:59`,
        this.succeed,
        new Date().getTimezoneOffset() * -1
      )
      .subscribe((pagination) => {
        this.pagination = pagination;
        this.loading = false;
      });
  }

  ngOnInit(): void {
    this.getWithdrawList();
  }
}
